var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26573_38128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2634 12.267C11.1801 13.0928 9.86088 13.5503 8.49884 13.5725C4.06243 13.5725 1.52734 8.50235 1.52734 8.50235C2.31569 7.0332 3.4091 5.74963 4.73423 4.73774M7.16791 3.58428C7.60416 3.48216 8.0508 3.43112 8.49884 3.43217C12.9352 3.43217 15.4703 8.50235 15.4703 8.50235C15.0856 9.22206 14.6268 9.89965 14.1014 10.5241M9.84243 9.84594C9.66837 10.0327 9.45846 10.1826 9.22524 10.2865C8.99201 10.3904 8.74024 10.4463 8.48495 10.4508C8.22966 10.4553 7.97608 10.4083 7.73933 10.3127C7.50258 10.2171 7.28752 10.0748 7.10698 9.89421C6.92643 9.71366 6.7841 9.4986 6.68847 9.26185C6.59285 9.02511 6.54588 8.77152 6.55039 8.51623C6.55489 8.26094 6.61077 8.00918 6.71469 7.77595C6.81861 7.54272 6.96844 7.33282 7.15524 7.15875",
    stroke: "#F0F0F0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52734 1.53084L15.4703 15.4738",
    stroke: "#F0F0F0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26573_38128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.9d4e80403e8ff62f42b529d1278118e7.svg";
export { ForwardRef as ReactComponent };